import { getDocumentObject } from '../common/utils/commonUtils'
import { FLAGS_PARAM_NAME } from '../flags/useFlags'

export const getIsMixpanelDebugEnabled = () => {
  if (getDocumentObject() && typeof localStorage !== undefined) {
    const devFlags = localStorage.getItem(FLAGS_PARAM_NAME)
    return devFlags ? JSON.parse(devFlags).enableMixpanelDebug : false
  }
  return false
}

export const toggleEnableMixpanelDebugWeb = () => {
  if (getDocumentObject() && typeof localStorage !== undefined) {
    const devFlags = localStorage.getItem(FLAGS_PARAM_NAME)
    const enableMixpanelDebug = getIsMixpanelDebugEnabled()

    const newFlags = JSON.parse(devFlags ?? '{}')
    if (enableMixpanelDebug) {
      delete newFlags.enableMixpanelDebug
    } else {
      newFlags.enableMixpanelDebug = true
    }
    localStorage.setItem(FLAGS_PARAM_NAME, JSON.stringify(newFlags))
    window.location.reload()
  }
}

// Universal Search Debug Settings (Web only - uses localStorage)
export interface UniversalSearchDebugSettings {
  autoSearch: boolean
  showDebug: boolean
}

export const getUniversalSearchDebugSettings = (): UniversalSearchDebugSettings => {
  if (getDocumentObject() && typeof localStorage !== undefined) {
    const devFlags = localStorage.getItem(FLAGS_PARAM_NAME)
    if (devFlags) {
      const parsed = JSON.parse(devFlags)
      return {
        autoSearch: parsed.universalSearchAutoSearch ?? false,
        showDebug: parsed.universalSearchShowDebug ?? true,
      }
    }
  }
  return { autoSearch: false, showDebug: true }
}

export const toggleUniversalSearchAutoSearchWeb = () => {
  if (getDocumentObject() && typeof localStorage !== undefined) {
    const devFlags = localStorage.getItem(FLAGS_PARAM_NAME)
    const currentSettings = getUniversalSearchDebugSettings()

    const newFlags = JSON.parse(devFlags ?? '{}')
    newFlags.universalSearchAutoSearch = !currentSettings.autoSearch
    localStorage.setItem(FLAGS_PARAM_NAME, JSON.stringify(newFlags))
  }
}

export const toggleUniversalSearchShowDebugWeb = () => {
  if (getDocumentObject() && typeof localStorage !== undefined) {
    const devFlags = localStorage.getItem(FLAGS_PARAM_NAME)
    const currentSettings = getUniversalSearchDebugSettings()

    const newFlags = JSON.parse(devFlags ?? '{}')
    newFlags.universalSearchShowDebug = !currentSettings.showDebug
    localStorage.setItem(FLAGS_PARAM_NAME, JSON.stringify(newFlags))
  }
}
